import { convertToQueryString } from 'app/shared/functions';
import { HttpClient } from 'app/library/client';
import { IListFilter, ResponseBase, ResponseContentBase, ResponseListBase } from "app/shared";
import { ActivityTypeEntity } from './types';
import { getEndpoint } from 'app/utils/service';

export class ActivityTypeService {

    /** It gets all ActivityType. */
    async getActivityTypes(options: IListFilter): Promise<ResponseBase<ResponseListBase<ActivityTypeEntity[]>>> {
        return HttpClient.getClient().get(getEndpoint('/activity-type/search') + `?${convertToQueryString(options)}`);
    }

    /** It get spesific ActivityType by ActivityType id */
    async getActivityType(id: string, language: string): Promise<ResponseBase<ResponseContentBase<ActivityTypeEntity>>> {
        return HttpClient.getClient().get(getEndpoint('/activity-type/') + id + `?language=${language || "en"}`);
    }

    /** It creates ActivityType by request */
    async createActivityType(request: ActivityTypeEntity): Promise<ResponseBase<ResponseContentBase<ActivityTypeEntity>>> {
        return HttpClient.getClient().post(getEndpoint('/activity-type/'), request);
    }

    /** It updates spesific ActivityType by id */
    async updateActivityType(request: ActivityTypeEntity): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().patch(getEndpoint('/activity-type/') + request.id, request);
    }

    /** It deletes spesific ActivityType by id */
    async deleteActivityType(id: string): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().delete(getEndpoint('/activity-type/') + id);
    }
}
